export const INSTRUCTION_LINKS = {
  customer: 'https://confluence.trucker.group/manual/gruzovladel-tsy-2519700569.html',
  executor: 'https://confluence.trucker.group/manual/perevozchiki-2519700567.html',
  withoutCompany: 'https://confluence.trucker.group/manual',
};
